import { useCallback, useState, useContext } from 'react';
import { AssessmentContext } from '../../context/AssessmentContext.js';
import { WebSocketContext } from '../../context/WebSocketContext.js';
import TimedAutoExitDialog from './TimedAutoExitDialog.js';
import * as PwaEvents from '../../context/PwaEvents.js';
import { Typography } from '@mui/material';
import CustomDialog from '../ui/feedback/CustomDialog.js';
import { NETWORKORSAVE_ERROR_DIALOG } from './LearnosityDialogs.js';
import { useTranslation } from 'react-i18next';

const NetworkOrSaveErrorDialog = ({ open }) => {
  const { setExit } = useContext(AssessmentContext);
  const { sendMsgToWebsocket } = useContext(WebSocketContext);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const { t } = useTranslation();

  //Dialog actions for Awaiting authorization
  const EXIT_CONFIRMATION_DIALOG_ACTIONS = [
    {
      label: t('components.networkOrSaveErrorDialog.continueWaiting'),
      handle: () => {
        setOpenConfirmationDialog(false);
      },
    },
    {
      label: t('common.yes'),
      handle: async () => {
        onComplete();
      },
    },
  ];

  //learnosity custom dialog detailss
  const EXIT_CONFIRMATION_DIALOG_DETAIL = {
    title: t('components.networkOrSaveErrorDialog.confirmationTitle'),
    message: (
      <Typography>
        {t('components.networkOrSaveErrorDialog.confirmationMessage')}
      </Typography>
    ),
    actions: EXIT_CONFIRMATION_DIALOG_ACTIONS,
  };

  const onComplete = useCallback(() => {
    sendMsgToWebsocket(PwaEvents.TEST_ABORTED_COMMUNICATION);
    setExit(true);
  }, [setExit, sendMsgToWebsocket]);

  const NETWORKORSAVE_ERROR_ACTIONS = [
    {
      label: t('common.exit'),
      handle: () => {
        setOpenConfirmationDialog(true);
      },
    },
  ];

  return (
    <>
      {openConfirmationDialog && (
        <CustomDialog
          open={openConfirmationDialog}
          dialogProps={EXIT_CONFIRMATION_DIALOG_DETAIL}
        />
      )}
      <TimedAutoExitDialog
        runBackground={openConfirmationDialog}
        open={open}
        dialogDetails={NETWORKORSAVE_ERROR_DIALOG()}
        onComplete={onComplete}
        actions={NETWORKORSAVE_ERROR_ACTIONS}
        duration={600}
      />
    </>
  );
};

export default NetworkOrSaveErrorDialog;
